'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateDelayMs = void 0;
var truncateDelayMs = function (delayMs) {
    return Math.min(Math.ceil(delayMs), 0x7fffffff);
};
exports.truncateDelayMs = truncateDelayMs;
